// Shared types and helpers for the /api/v2/analytics/filter_options/* endpoints.

export type FilterOption = {
	label: string;
	value: string;
};

export type FilterOptionsGroup = {
	key: string;
	label: string;
	options: FilterOption[];
};

// Maps the canonical grouped response into the flat `{key => values[]}` shape
// that existing consumers (custom-property dropdowns) expect.
export const filterOptionsGroupsToFlatRecord = (groups: FilterOptionsGroup[]): Record<string, string[]> =>
	Object.fromEntries(groups.map((group) => [group.key, group.options.map((option) => option.value)]));
